import dayjs from "dayjs"
import LocalizedFormat from "dayjs/plugin/localizedFormat"

dayjs.extend(LocalizedFormat)

export const DEFAULT_DATE_FORMAT = "L"

export const formatDate = (
  date: Date,
  locale = "en",
  format: string = DEFAULT_DATE_FORMAT
): string => {
  return dayjs(date).locale(locale).format(format)
}
